import React, { Component } from 'react';
import { Route } from 'react-router-dom';

import Main from "./components/main/Main"
import Entrance from "./components/entrance/Entrance"

class App extends Component {
  render() {
    return (
      <div className="App">
        <Route exact path="/" component={Main}/>
        <Route path="/main" component={Main}/>
      </div>
    );
  }
}

export default App;